<template>
    <van-popup
            v-if="selectCodePopupShow" v-model="selectCodePopupShow" z-index="100" :close-on-click-overlay="false" @click-overlay="handleClickClose"
            :style="{ height: '100vh',width: '100vw', background: '#fff' }" overlay-class="custom_popup" position="right">

        <div class="product_code_wrap" v-loading="loading">
            <div class="product_code_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
               <div class="search_wrap" v-if="stockType != 'transfer_in' && stockType != 'transfer_in_cancel'">
                   <van-search v-model="searchForm.keyword"  placeholder="请输入产品编码"  @clear="handleClickSearch" @search="handleClickSearch"></van-search>
               </div>
            </div>
            <div class="product_code_content">
                <p>已选 <span v-text="selectionIds.length"></span></p>
                <span class="cancel" @click="multipleSelection = [];selectionIds = []">取消选择</span>
            </div>
            <div class="product_code_bottom">
                <van-checkbox-group v-model="selectionIds" :max="maxChangeNum"  @change="handleSelectionChange">
                    <ul v-infinite-scroll="onLoadList" :infinite-scroll-disabled="(stockType === 'transfer_in' || stockType === 'transfer_in_cancel') ? true : false">
                        <li v-for="(item, index) in codeData" :key="item.code" @click="handleLiClick(index)">
                            <van-checkbox icon-size="16px" :name="item.code" shape="square" ref="checkboxes" :disabled="!isSelectable(item, index)"  readonly />
                            <template>
                                <van-toast v-if="item.status === 2" :message="'已报废'" position="top" />
                                <p v-text="item.code"></p>
                            </template>
                        </li>
                    </ul>
                </van-checkbox-group>

            </div>
            <div class="product_code_footer">
                <van-button round block type="info" @click="handleClickConfirm" :disabled="BtnDisabled">确定</van-button>
            </div>

        </div>
    </van-popup>

</template>

<script>
import { chooseCode} from "@/api/index.js"
import {pagination} from '@/mixins'
import {Dialog} from "vant";
export default {
    name: "select_code",
    components: {},
    props: {
        selectCodePopupShow: {
            type: Boolean,
            default: false,
        },
        selectedCodeData: {
            type: Array,
            default: ()=>{},
        },
        productInfo: {
            type: Object,
            default: ()=>{}
        },
        maxChangeNum: {
            type: Number,
            default: 0
        },
        relatedId: {
            type: Number,
            default: 0
        },
        stockType: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            loading: false,
            BtnDisabled:false,
            searchForm:{
                keyword: '',
            },
            lastTimeCode:[], //上一次选择的编码
            codeData:[],
            multipleSelection:[],
            selectionIds:[]

        };
    },
    mixins: [pagination],
    created() {

        if(this.stockType != 'transfer_in' && this.stockType != 'transfer_in_cancel'){
            if(this.productInfo.code_list){
                this.lastTimeCode = JSON.parse(JSON.stringify(this.productInfo.code_list))
            }
            this.multipleSelection = JSON.parse(JSON.stringify(this.productInfo.code_list))
            this.selectionIds = this.multipleSelection.map(item=>item.code)
            this.getTableData()
        }else{
            if(this.productInfo.code_list){
                this.lastTimeCode = this.productInfo.code_list.map((item)=>{
                    return {
                        code:item
                    }
                })
            }
            if(this.productInfo.all_code_list){
                this.productInfo.all_code_list.map((item,key)=>{
                    let json = {
                        code:item,
                        id:key
                    }
                    this.codeData.push(json)
                    if(this.productInfo.code_list.findIndex(find => find == item) > -1){
                        this.multipleSelection.push(json)
                        this.selectionIds.push(item)
                    }
                })
            }

        }
    },
    mounted() {

    },
    methods: {
        handleClickSearch(){
            this.codeData = []
            this.pagination.pageNum = 1
            this.getTableData()
        },

        // isSelectable(item, index) {
        //     // 采购退货
        //     if(item.hasOwnProperty('code2') &&  (item.code2 == null || item.code2 == 'null')){
        //         return false
        //     }
        //     // 别的产品选择了就不能再选了
        //     if(this.selectedCodeData.find(find => find.code == item.code)){
        //         return false
        //     }
        //     if(this.maxChangeNum == 0){
        //         return  true
        //     }
        //     return this.multipleSelection.find(find => find.code == item.code) ? true : this.multipleSelection.length < this.maxChangeNum
        // },
        //
        // handleChangeCheck(index,item){
        //     this.$nextTick(()=>{
        //         if(!this.selectionIds.includes(item.code)){
        //             this.multipleSelection.push(item)
        //             this.selectionIds.push(item.code)
        //         }else{
        //             this.multipleSelection.splice(this.multipleSelection.findIndex(list=>list.code == item.code),1)
        //             this.selectionIds.splice(this.selectionIds.findIndex(list=>list == item.code),1)
        //         }
        //     })
        // },



        isSelectable(row, index) {
            // 采购退货
            if (row.hasOwnProperty('code2') && (row.code2 === null || row.code2 === 'null')) {
                return false;
            }
            // 别的产品选择了就不能再选了
            if (this.selectedCodeData.find((find) => find.code === row.code)) {
                return false;
            }
            if (this.maxChangeNum === 0) {
                return true;
            }
            // 已经选够数量时，禁用其他未选中项
            if (this.multipleSelection.length >= this.maxChangeNum &&!this.multipleSelection.find((find) => find.code === row.code)) {
                return false;
            }
            return this.multipleSelection.find((find) => find.code === row.code) ? true  : this.multipleSelection.length < this.maxChangeNum;
        },
        handleLiClick(index) {
            const checkbox = this.$refs.checkboxes[index];
            if (checkbox) {
                checkbox.$el.click();
            }
        },
        handleSelectionChange(selectionIds) {
            const selection = selectionIds.map((code) => this.codeData.find((item) => item && item.code === code)).filter(Boolean);
            if (this.maxChangeNum > 0) {
                if (selection.length > this.maxChangeNum) {
                    selection.splice(this.maxChangeNum);
                    this.selectionIds = selection.map((item) => item.code);
                }
            }

            let result = selection.filter((item2) => {
                // 检查 status 是否为 2  不包含上一次选择的编码
                return item2 && item2.status === 2 && !this.lastTimeCode.find((find) => find && find.code === item2.code)
                        && !this.multipleSelection.some((item1) => item1 && item1.code === item2.code && item1.id === item2.id);
            });
            this.lastTimeCode = this.lastTimeCode.filter((item) => {
                return item &&!selection.find((find) => find && find.code === item.code);
            });
            if (result && result.length > 0) {
                Dialog.confirm({
                    title: '异常编码',
                    message: '您当前选择出库的编码为异常状态是否选中！',
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                }).then(() => {
                    this.multipleSelection = selection;
                }).catch(() => {
                    let selectData = selection.filter((item1) => {
                        // 使用 some 检查 item1 是否在 data2 中
                        return item1 &&!result.some((item2) => item2 && item1.code === item2.code && item1.id === item2.id && item1.status === item2.status);
                    });
                    this.selectionIds = selectData.map((item) => item.code);
                    this.multipleSelection = selectData;
                    this.$forceUpdate(); // 强制更新组件，确保复选框状态更新
                });
            } else {
                this.multipleSelection = selection;
                this.$forceUpdate(); // 强制更新组件，确保复选框状态更新
            }
            this.$forceUpdate(); // 强制更新组件，确保复选框状态更新
        },


        onLoadList(){
            if(this.pagination.total == this.codeData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.searchForm.keyword,
                product_name:this.productInfo.name,
                sku_id:this.productInfo.sku_id,
                stock_id:this.productInfo.stock_id,
                stock_type:this.stockType
            }
            if(this.relatedId){
                postData.related_id = this.relatedId
            }
            if(this.productInfo && this.productInfo.related_detail_id){
                postData.related_detail_id = this.productInfo.related_detail_id
            }
            chooseCode(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    this.codeData = this.codeData.concat(list)
                    this.pagination.total = total
                    this.pagination.pageNum++;
                }else{
                    this.btnDisabled = false
                }
                this.loading = false
            })
        },
        handleClickConfirm() {
            this.$emit("success", this.multipleSelection)
            this.$emit("update:selectCodePopupShow", false)

        },
        handleClickClose(){
            this.$emit("update:selectCodePopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
.custom_popup {
    background-color: rgba(0, 0, 0, 0.3);
}
.product_code_wrap{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    .product_code_top{
        width: 100%;
    }
    .product_code_content{
        width: 100%;
        background: rgba(247, 248, 250, 1);
        height: 42px;
        padding: 0 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        p{
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            span{
                font-size: 14px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
            }
        }
        .cancel{
            font-size: 14px;
            color: rgba(228, 65, 68, 1);
        }
    }

    .product_code_bottom{
        flex: 1;
        overflow: auto;
        background: #fff;
        padding: 2px 0;
        box-sizing: border-box;
        ul{
            width: 100%;
            padding: 0 16px;
            box-sizing: border-box;
            li{
                width: 100%;
                line-height: 42px;
                border-bottom: 1px solid rgba(232, 232, 232, 1);
                box-sizing: border-box;
                display: flex;
                ::v-deep .van-checkbox__icon .van-icon{
                    border-radius: 4px;
                    border-color: rgba(217, 217, 217, 1);
                }
                p{
                    margin-left: 8px;
                    color:rgba(102, 102, 102, 1) ;
                    font-size: 14px;
                }
            }
        }
    }
    .product_code_footer{
        width: 100%;
        padding: 12px 16px;
        padding-bottom:calc(12px + env(safe-area-inset-bottom)) ;
        .van-button{
            height: 38px;
            border-radius: 6px;
        }
    }

}

</style>